module.exports = "/fonts/intelliboard.svg?ad67af16a2f3032de98a784a5e3a82d3";